const utils = {
    shape: {
        borderRadius: 6,
    },
    spacing: (factor) => `${0.5 * factor}rem`,
};

export default utils;
